module.exports = __webpack_public_path__ + "static/media/floating-sticky-icon.f3297c2f.svg";